import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ClientLayout from "../../component/appLayouts/clientLayout/clientLayout";
import DevisService from "../../services/devis.service";
import { getUserByID } from "../../services/user.service";
import DataTableDisplay from "../../component/ListeDevis/ListeDevis";
import DevisUser from "../../component/devisUser";
import "./index.scss";
import { useAuth } from "../../component/authProvider";
import ArrowBack from "../../component/icons/arrowBack";

const UserDetails = () => {
  const { id } = useParams(); // l'ID de l'utilisateur
  const [user, setUser] = useState(null);
  const [devisList, setDevisList] = useState([]);
  const [devisLists, setDevisLists] = useState([]);
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const fetchUserDevis = async () => {
    setLoading(true);

    try {
      console.log("🚀 ~ fetchUserDevis ~ currentUser:", currentUser);
      if (currentUser.role === "gestionnaire" || currentUser.role === "admin") {
        const res = await DevisService.getAllClientsDevis(); // <-- fetch all devis
        console.log("🚀 ~ fetchUserDevisgg ~ res:", res);
        setDevisLists(res);
      } else {
        const res = await DevisService.getDevisByUserId(currentUser.userId); // <-- fetch user's devis
        console.log("🚀 ~ fetchUserDevishhh ~ res:", res);
        setDevisLists(res);
      }
    } catch (error) {
      console.error(error); // Log the error for debugging
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      const fetchUserAndDevis = async () => {
        try {
          const devis = await DevisService.getDevisByUserId(id);
          setDevisList(devis);

          // Appel séparé pour obtenir l'utilisateur
          const userResponse = await getUserByID(id);
          setUser(userResponse);
        } catch (error) {
          console.error("Error fetching user and devis:", error);
        }
      };

      fetchUserAndDevis();
    }
  }, [id]);

  if (!user) return <p>Chargement...</p>;

  return (
    <ClientLayout>
      <div className="d-lg-flex justify-content-between my-4">
        <h5 className="text-black">
          <Link
            className="text-black text-capitalize"
            onClick={() => navigate(-1)}
          >
            <ArrowBack />
            Détails de l'utilisateur
          </Link>
        </h5>
      </div>
      <div className="user-details">
        <div className="section">
          <p>
            <strong>Nom :</strong> {user?.firstname} {user?.lastname}
          </p>
          <p>
            <strong>Email :</strong> {user?.email}
          </p>
          <p>
            <strong>Téléphone :</strong> {user?.phone}
          </p>
          <p>
            <strong>Rôle :</strong> {user?.Role}
          </p>
          <p>
            <strong>Statut :</strong> {user?.status}
          </p>
          <p>
            <strong>Pays :</strong> {user?.country}
          </p>
          <p>
            <strong>Ville :</strong> {user?.city}
          </p>
          {user?.SIRET && (
            <p>
              <strong>SIRET :</strong> {user.SIRET}
            </p>
          )}

          {user?.SIREN && (
            <p>
              <strong>SIREN :</strong> {user.SIREN}
            </p>
          )}
          {user?.KBIS && (
            <p>
              <strong>KBIS :</strong>
              <a
                href={`${process.env.REACT_APP_API_URL}/users/image/${user._id}/kbis`}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                Télécharger
              </a>{" "}
            </p>
          )}
          <p>
            <strong>Date de création :</strong>{" "}
            {new Date(user?.createdAt).toLocaleDateString()}
          </p>
          <p>
            <strong>Date de mise à jour :</strong>{" "}
            {new Date(user?.updatedAt).toLocaleDateString()}
          </p>
          {user?.company && (
            <p>
              <strong>Entreprise :</strong> {user.company}
            </p>
          )}
          {user?.activitySector && (
            <p>
              <strong>Secteur d'activité :</strong> {user.activitySector}
            </p>
          )}
        </div>

        {user?.Role === "client" ? (
          <div className="section">
            <h3>Liste des devis</h3>
            {devisList.length > 0 ? (
              <DevisUser
                devisList={devisList}
                fetchUserDevis={fetchUserDevis}
              />
            ) : (
              <p className="no-devis">
                Aucun devis trouvé pour cet utilisateur.
              </p>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </ClientLayout>
  );
};

export default UserDetails;
